export const  retLastSegmentURL=(url)=> {
    return url.substring(url.lastIndexOf('/') + 1)
}